import React from 'react';

import { EditGeneralSettingsContext } from './EditGeneralSettingsContext';

const useEditGeneralSettingsContext = () => React.useContext(EditGeneralSettingsContext);

export { useEditGeneralSettingsContext };
